module.exports = __webpack_public_path__ + "media/images/pic/brodno/teddy-teacher-ac80ecd98c8d232d78ddaee6b01af9e5.png";